import http from './http'

export function sessionKey () {
  return http.get(`/payment/sagepay-merchant-session-key`)
}
